import { useQuery } from '@apollo/client';
import { GET_ACTIVE_DOCUMENTS } from '../../graphql/queries';

export interface DocumentRecord {
  uuid: string;
  studyId?: string;
  patientId: string;
  carePlanId?: string;
  careActivityId?: string;
  typeId: string;
  name: string;
  status: string;
}

interface GetActiveDocumentsResponse {
  getActiveDocuments: DocumentRecord[];
}

interface GetActiveDocumentsVars {
  studyId?: string;
  carePlanId?: string;
}

export const useGetActiveDocuments = (
  studyId?: string,
  carePlanId?: string,
): {
  documents?: DocumentRecord[];
  loading: boolean;
  error?: any;
  refetch: () => Promise<any>;
} => {
  const variables: GetActiveDocumentsVars = carePlanId ? { carePlanId } : { studyId };

  const { data, loading, error, refetch } = useQuery<
    GetActiveDocumentsResponse,
    GetActiveDocumentsVars
  >(GET_ACTIVE_DOCUMENTS, {
    variables,
    fetchPolicy: 'no-cache',
  });

  return {
    documents: data?.getActiveDocuments,
    loading,
    error,
    refetch,
  };
};
